'use client';

import { useRouter } from 'next/navigation';
import Image from 'next/image';
import Button from '@/components/shared/Button';
import { ReactNode } from 'react';

type ButtonBackProps = {
    fallbackHref?: string;
    children?: ReactNode;
    className?: string;
    icon?: ReactNode;
};

const ButtonBack = ({
    fallbackHref = '/',
    children = 'Назад',
    className = '',
    icon = <Image src="/img/back.svg" fill unoptimized alt="" />,
}: ButtonBackProps) => {
    const router = useRouter();

    const handleBack = () => {
        if (window.history.length > 1) {
            router.back();
        } else {
            router.push(fallbackHref);
        }
    };

    return (
        <Button
            icon={icon}
            iconReverse
            onClick={handleBack}
            className={`back-button back-button-clickable ${className}`}
            geometryVariant="arrow"
        >
            {children}
        </Button>
    );
};

export default ButtonBack;
